import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useLowData } from "@/lib/i18n";
import { useParametres } from "@/hooks/useParametres";
import { RESEAUX_SOCIAUX } from "./SocialLinks";

export function Footer() {
  const { t } = useI18n();
  const { lowData, toggle } = useLowData();
  const year = new Date().getFullYear();
  const { data: parametres } = useParametres();
  const texteFooter = parametres?.["footer.texte"];
  const siteTitre = parametres?.["site.titre"] || "RAMBA NEWS";
  const reseauxActifs = RESEAUX_SOCIAUX.filter((r) => parametres?.[r.cle]);

  return (
    <footer className="mt-20 border-t border-border bg-surface">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              {parametres?.["site.logo"] ? (
                <img src={parametres["site.logo"]} alt={siteTitre} className="h-8 w-8 rounded-sm object-contain" />
              ) : (
                <div className="flex h-8 w-8 items-center justify-center rounded-sm bg-foreground text-background font-serif text-base font-semibold">
                  {siteTitre.charAt(0)}
                </div>
              )}
              <div className="text-base font-semibold tracking-tight">{siteTitre}</div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
              {texteFooter || t("footer.description")}
            </p>
            {reseauxActifs.length > 0 && (
              <div className="mt-4 flex items-center gap-3">
                {reseauxActifs.map(({ cle, label, Icon }) => (
                  <a
                    key={cle}
                    href={parametres?.[cle]}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    className="flex h-8 w-8 items-center justify-center rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-foreground transition-colors"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                ))}
              </div>
            )}
            <div className="mt-5 flex items-center gap-3">
              <LanguageSwitcher />
              <button
                onClick={toggle}
                className={`inline-flex items-center gap-2 rounded-md border border-border px-2.5 py-1 text-xs font-medium transition-colors ${
                  lowData ? "bg-foreground text-background" : "bg-card text-muted-foreground hover:text-foreground"
                }`}
                aria-pressed={lowData}
              >
                <span className="h-1.5 w-1.5 rounded-full bg-current" />
                {t("label.lowData")}
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground">Ramba News</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/about" className="text-muted-foreground hover:text-foreground">{t("footer.about")}</Link></li>
              <li><Link to="/editorial" className="text-muted-foreground hover:text-foreground">{t("footer.editorial")}</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-foreground">{t("footer.contact")}</Link></li>
              <li><Link to="/languages" className="text-muted-foreground hover:text-foreground">{t("footer.languages")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground">{t("footer.legal")}</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground">{t("footer.privacy")}</Link></li>
              <li><Link to="/terms" className="text-muted-foreground hover:text-foreground">{t("footer.terms")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-rule pt-6 flex items-center text-xs text-muted-foreground">
          <span>{t("footer.copy", { year })}</span>
        </div>
      </div>
    </footer>
  );
}
